/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgPersonalInjuryProtection32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M29 30l-2.093-8.022a4.653 4.653 0 00-4.502-3.478H21.26a2.17 2.17 0 01-1.884-1.093L18 15M15 15l-1.022 2.233a2.17 2.17 0 01-1.973 1.267h-1.78a4.653 4.653 0 00-4.357 3.019L3.26 28.475A1.5 1.5 0 004.664 30.5h16.96a2.421 2.421 0 002.421-2.42v-.002a2.83 2.83 0 00-1.984-2.701l-1.561-.489'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M11.5 18.5h1.898l6.102 12h-3'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M21.5 7.483A4.484 4.484 0 0017.017 3h-1.034A4.484 4.484 0 0011.5 7.483v3.034A4.484 4.484 0 0015.983 15h1.034a4.484 4.484 0 004.483-4.483V7.483v0z'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M14.39 7.96l2.174-.442A3.723 3.723 0 0018.874 6'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M14.39 7.96l2.174-.442A3.723 3.723 0 0018.874 6'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M11.023 24.977V22h-.046v2.977H8v.046h2.977V28h.046v-2.977H14v-.046h-2.977z'
      />
      <path
        fill='currentColor'
        d='M11.023 22h.75v-.75h-.75V22zm0 2.977h-.75v.75h.75v-.75zM10.977 22v-.75h-.75V22h.75zm0 2.977v.75h.75v-.75h-.75zm-2.977 0v-.75h-.75v.75H8zm0 .046h-.75v.75H8v-.75zm2.977 0h.75v-.75h-.75v.75zm0 2.977h-.75v.75h.75V28zm.046 0v.75h.75V28h-.75zm0-2.977v-.75h-.75v.75h.75zm2.977 0v.75h.75v-.75H14zm0-.046h.75v-.75H14v.75zM10.273 22v2.977h1.5V22h-1.5zm.704.75h.046v-1.5h-.046v1.5zm.75 2.227V22h-1.5v2.977h1.5zM8 25.727h2.977v-1.5H8v1.5zm.75-.704v-.046h-1.5v.046h1.5zm2.227-.75H8v1.5h2.977v-1.5zm.75 3.727v-2.977h-1.5V28h1.5zm-.704-.75h-.046v1.5h.046v-1.5zm-.75-2.227V28h1.5v-2.977h-1.5zm3.727-.75h-2.977v1.5H14v-1.5zm-.75.704v.046h1.5v-.046h-1.5zm-2.227.75H14v-1.5h-2.977v1.5z'
      />
    </svg>
  );
}

export default SvgPersonalInjuryProtection32;
